import rgbStringfy from './rgbStringfy';
import rgbToHex from './rgbToHex';
/**
 * Transform a RGB Array to another color format
 */
export default function formatRGB(arrayRGB, format) {
    var responses = {
        rgbString: function () { return rgbStringfy.apply(void 0, arrayRGB); },
        hex: function () { return rgbToHex.apply(void 0, arrayRGB); },
        rgbArray: function () { return arrayRGB; }
    };
    return responses[format]();
}
//# sourceMappingURL=formatRGB.js.map